export const WRITINGS = [
  {
    date: "Oct 2026",
    tags: "UX · AI · B2B",
    title: "Can AI make the user experience worse?",
    blurb: "Faster isn’t always better UX: in one 50-field flow, manual beat AI on completion.",
    href: "https://medium.com/@jiadiyounghe/can-ai-make-the-user-experience-worse-faster-isnt-always-better-ux-73538d2013d5",
  },
  {
    date: "Oct 2026",
    tags: "Teaching · AI · UX",
    title: "“What is hover?”",
    blurb: "Teaching vibe coding outside the tech bubble, and the interface words we skip.",
    href: "https://medium.com/@jiadiyounghe/what-is-hover-teaching-vibe-coding-outside-the-tech-bubble-7fca0a67968e",
  },
];
